import React from 'react'
import styled from 'styled-components'
import {RequiredAsterisk} from './RequiredAsterisk'

const StyledLabel = styled.label`
  display: block;
  color: var(--neutral-600);
  font-family: var(--font-sans);
  font-size: var(--fs-caption);
  font-style: normal;
  font-weight: 400;
`

interface FormLabelProps {
  children: React.ReactNode
  required?: boolean
  htmlFor?: string
}

export const FormLabel: React.FC<FormLabelProps> = ({children, required, htmlFor}) => {
  return (
    <StyledLabel htmlFor={htmlFor} data-testid="form-label">
      {children}
      {required && <RequiredAsterisk />}
    </StyledLabel>
  )
}

export default FormLabel
